import React from 'react';
import { Card, Heading, Table, Strong } from 'evergreen-ui';
import { formatCurrency } from '../../../util';

const ExpenseCategoryTable = ({ data, formatCurrencyWithSymbol, currencySymbol }) => {
    const total = data?.reduce((sum, item) => sum + item.total_amount, 0) || 0;

    return (
        <Card flex={1} padding={16} background="tint1" elevation={1}>
            <Heading size={600} marginBottom={16}>Expenses by Category</Heading>
            <Table>
                <Table.Head>
                    <Table.TextHeaderCell>Category</Table.TextHeaderCell>
                    <Table.TextHeaderCell textAlign="right">Amount</Table.TextHeaderCell>
                </Table.Head>
                <Table.Body>
                    {data?.map((item, index) => (
                        <Table.Row key={index}>
                            <Table.TextCell>{item.category}</Table.TextCell>
                            <Table.TextCell textAlign="right">
                                {formatCurrencyWithSymbol(item.total_amount)}
                            </Table.TextCell>
                        </Table.Row>
                    ))}
                    <Table.Row intent="success">
                        <Table.TextCell><Strong>Total</Strong></Table.TextCell>
                        <Table.TextCell textAlign="right">
                            <Strong>{formatCurrencyWithSymbol(total)}</Strong>
                        </Table.TextCell>
                    </Table.Row>
                </Table.Body>
            </Table>
        </Card>
    );
};

export default ExpenseCategoryTable;
